import { codecoRawEvent } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getCodecoRawEventList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(codecoRawEvent.codecoRawEventBase, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getCodecoRawEventStatusCounts(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${codecoRawEvent.codecoRawEventBase}status_counts/`, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getCodecoRawEventDashboardSummary(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${codecoRawEvent.codecoRawEventBase}dashboard_summary/`, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getCodecoRawEventBreakdown(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${codecoRawEvent.codecoRawEventBase}breakdown/`, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getCodecoRawEventFailedRows(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${codecoRawEvent.codecoRawEventBase}failed_rows/`, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  requeueCodecoRawEventFailed(payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${codecoRawEvent.codecoRawEventBase}requeue_failed/`, payload)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
});
